import api from '../services/api';
export const atendimetoWhatsapp = async (msg) => {
    logNavegacao('atendimento', 'whatsapp');
    let phoneWithCountryCode = "+5521967471625";
    let url = "https://wa.me/"+phoneWithCountryCode+"?text=" + msg;
    window.open(url, '_blank', 'noreferrer');
}

export function logNavegacao (type, navegacao){
    api.post(`/clients/log`,{
        type,
        navegacao,
        origem: 'Area cliente'
    }).then(function (response) {
    }).catch(function(error){
        console.log(error)
    });
}